const FLASH_NAVBAR_HEIGHT = "56px";
export {
  FLASH_NAVBAR_HEIGHT
};
//# sourceMappingURL=constants.js.map
